module.exports = require("x-ray");


//////////////////
// WEBPACK FOOTER
// external "x-ray"
// module id = 1
// module chunks = 0